import internalApi from "@/internalApi.js";
import { ref } from "vue";


export default function mainComposable(store) {
    const isProcessing = ref(false);
    const isLoading = ref(false);
    let currentPath = window.location.pathname; // Get the current path
    if (currentPath.charAt(0) === '/') {
        currentPath = currentPath.substring(1); // Remove the first character if it's a slash
    }
    // function ensureHttps(url) {
    //     if (url.startsWith("http://")) {
    //         console.log('https inside fn : '+url)
    //         url = url.replace(/^http:\/\//, "https://");
    //         console.log('https after replace fn : '+url)

    //     }
    //     console.log('https : '+url)
    //     return url;
    // }
    function ensureHttps(url) {
        if (!url) return url;

        // Parse the URL to get its hostname
        let urlHostname;
        try {
            urlHostname = new URL(url).hostname;
        } catch (e) {
            console.warn('Invalid URL:', url);
            return url;
        }

        const isLocalDev = urlHostname === '127.0.0.1' || urlHostname === 'localhost';
        const currentProtocol = window.location.protocol;

        // For local development, always use HTTP
        if (isLocalDev) {
            if (url.startsWith("https://")) {
                console.log('Converting HTTPS to HTTP for local: ' + url);
                return url.replace(/^https:\/\//, "http://");
            }
            return url;
        }

        // For production URLs, match the current page's protocol
        if (currentProtocol === 'https:' && url.startsWith("http://")) {
            console.log('Converting to HTTPS: ' + url);
            return url.replace(/^http:\/\//, "https://");
        } else if (currentProtocol === 'http:' && url.startsWith("https://")) {
            console.log('Converting to HTTP: ' + url);
            return url.replace(/^https:\/\//, "http://");
        }

        console.log('URL unchanged: ' + url);
        return url;
    }
    const fetch = async (endpoint, params) => {

        endpoint = ensureHttps(endpoint)
        console.log('general fetching api.. end point ' + endpoint)
        isProcessing.value = true;
        try {
            return await internalApi.get(endpoint, {
                params: {
                    ...params,
                    path: currentPath
                }
            });
        } catch (error) {
            throw error;
        } finally {
            isProcessing.value = false;
        }
    };

    const fetchPdf = async (endpoint, params) => {

        isProcessing.value = true;
        try {
            return await internalApi.get(endpoint, {
                params: {
                    ...params,
                    path: currentPath
                },
                responseType: 'blob',
            });
        } catch (error) {
            throw error;
        } finally {
            isProcessing.value = false;
        }
    };

    const create = async (endpoint, payload, token) => {
        isLoading.value = true;
        try {
            const response = await internalApi.post(endpoint, payload);
            return response.data;
        } catch (error) {
            throw error;
        } finally {
            isLoading.value = false;
        }
    };

    const update = async (endpoint, id, payload) => {
        isLoading.value = true;
        try {

            let response = await internalApi.put(endpoint + "/" + id, payload);
            return response.data;
        } catch (e) {
            throw e;
        } finally {
            isLoading.value = false;
        }
    };

    const edit = async (endpoint) => {
        isLoading.value = true;
        let response = null;
        try {
            response = await internalApi.get(endpoint);
            return response.data;
        } catch (e) {
            return null;
        } finally {
            isLoading.value = false;
        }
    }

    const remove = async (endpoint, id) => {
        isProcessing.value = true;
        try {
            const response = await internalApi.delete(`${endpoint}/${id}`);
            return response.data;
        } catch (error) {
            throw error;
        } finally {
            isProcessing.value = false;
        }
    };

    const submit = async (endpoint, params, method = 'post', hasFile = false) => {
        console.log('submitting payload', params);
        isProcessing.value = true;
        try {
            const response = await internalApi[method](endpoint, params, hasFile);
            return response.data;
        } catch (error) {
            throw error;
        } finally {
            isProcessing.value = false;
        }
    };

    const post = async (endpoint, params, hasFile = true) => {
        isProcessing.value = true;
        try {
            let token = store.state.auth.token;
            const response = await internalApi.post(endpoint, params, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': hasFile ? 'multipart/form-data' : 'application/json',
                }
            });
            return response.data;
        } catch (error) {
            throw error;
        } finally {
            isProcessing.value = false;
        }
    };


    return {
        isProcessing,
        isLoading,
        edit,
        fetch,
        create,
        submit,
        update,
        remove,
        post,
        fetchPdf
    };
}
